import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import {
    DeviceLayoutConfigSectionDetails,
    DeviceLayoutConfigSectionProperty,
} from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-configuration-layout/settings-devices-configuration-layout.model';
import { PropertyComponent } from '../settings-devices-configuration.business';
import { SettingsHeaderSections } from '../settings-devices-configuration.style';
import { getVisibleHeaders, getVisibleProperties } from './settings-devices-configuration-layout-content.business';

interface SettingsDevicesConfigurationLayoutContentProps {
    sectionDetails: DeviceLayoutConfigSectionDetails;
    sectionTitle?: string;
    isFlexEnd: boolean;
    isPropertyHidden: (propertyName: DeviceLayoutConfigSectionProperty['name']) => boolean;
}

export const SettingsDevicesConfigurationLayoutContent: React.FC<SettingsDevicesConfigurationLayoutContentProps> = ({
    sectionDetails,
    sectionTitle,
    isFlexEnd,
    isPropertyHidden,
}) => {
    const visibleHeaders = getVisibleHeaders(sectionDetails, isPropertyHidden);
    const headerOccurrences = new Map<string, number>();
    const getHeaderKey = (headerName: string): string => {
        const occurrence = headerOccurrences.get(headerName) ?? 0;
        headerOccurrences.set(headerName, occurrence + 1);

        return `${sectionDetails.id}-${headerName}-${occurrence}`;
    };

    return (
        <div className="section-header">
            <PocTypography variant="title5" className="section-title">
                {sectionTitle}
            </PocTypography>
            {visibleHeaders.map((header) => (
                <SettingsHeaderSections key={getHeaderKey(header.name)}>
                    <PocTypography variant="subheader" className="header-title">
                        {header.displayName}
                    </PocTypography>
                    <div
                        data-testid={`header-properties-${header.name}`}
                        className={`header-properties ${isFlexEnd ? 'is-flex-end-layout' : ''}`}
                    >
                        {getVisibleProperties(header, isPropertyHidden).map((property) => (
                            <div key={property.name}>
                                <PropertyComponent property={property} />
                            </div>
                        ))}
                    </div>
                </SettingsHeaderSections>
            ))}
        </div>
    );
};
